import { Link } from "react-router-dom";
import useContent from "../lib/useContent";

const DEFAULT_CARDS = [
  { brand: "Rolex", subtitle: "The crown of horology — heritage and precision since 1905.", img: "https://images.unsplash.com/photo-1547996160-81dfa63595aa?w=1000", href: "/shop?brand=rolex" },
  { brand: "Patek Philippe", subtitle: "Geneva mastery — the ultimate grail of haute horlogerie.", img: "https://images.unsplash.com/photo-1620625515032-6ed0c1790c75?w=1000", href: "/shop?brand=patek-philippe" },
  { brand: "Audemars Piguet", subtitle: "Iconic Royal Oak — disrupting luxury since 1972.", img: "https://images.unsplash.com/photo-1622434641406-a158123450f9?w=1000", href: "/shop?brand=audemars-piguet" },
];

export default function BrandShowcase() {
  const { data } = useContent("homepage_curated", {
    title: "Crafted Excellence — Explore Top Brands.",
    overline: "Curated Selection",
    subtitle: "Discover iconic timepieces from the world's most revered manufactures. A legacy of precision, innovation, and Swiss watchmaking heritage.",
    items: DEFAULT_CARDS,
  });
  const cards = data?.items?.length ? data.items : DEFAULT_CARDS;

  return (
    <section className="max-w-[1500px] mx-auto px-6 md:px-12 py-24">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="overline mb-3">{data?.overline || "Curated Selection"}</div>
        <h2 className="font-display text-4xl md:text-5xl text-dark tracking-tight" dangerouslySetInnerHTML={{ __html: highlight(data?.title || "Crafted Excellence — Explore Top Brands.") }}/>
        <p className="text-gray-600 mt-5 text-sm">{data?.subtitle || "Discover iconic timepieces from the world's most revered manufactures."}</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {cards.map((c, idx) => (
          <Link to={c.href || "/shop"} key={`${c.brand}-${idx}`} data-testid={`brand-card-${c.brand}`} className="group relative aspect-[4/5] overflow-hidden bg-[#F5F2ED]">
            <img src={c.img} alt={c.brand} loading="lazy" onError={(e) => { e.currentTarget.src = "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=1000"; }} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"/>
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"/>
            <div className="absolute inset-0 p-8 flex flex-col justify-end">
              <div className="text-[11px] uppercase tracking-luxe font-semibold text-copper mb-2">Discover Collection</div>
              <h3 className="font-display text-3xl text-white">{c.brand}</h3>
              {c.subtitle && <p className="text-white/80 text-sm mt-2 leading-relaxed">{c.subtitle}</p>}
              <span className="text-xs uppercase tracking-luxe text-copper mt-4 inline-flex items-center gap-1 opacity-90 group-hover:opacity-100">Shop Now →</span>
            </div>
          </Link>
        ))}
      </div>
      <div className="text-center mt-10"><Link to="/shop" className="text-xs uppercase tracking-luxe text-gray-700 hover:text-copper">Explore All Collections →</Link></div>
    </section>
  );
}

// Wraps the part after "—" or italics in copper. Falls back to plain text.
function highlight(t) {
  if (!t) return "";
  const parts = t.split("—");
  if (parts.length === 2) return `${escapeHtml(parts[0])}— <em class="text-copper not-italic">${escapeHtml(parts[1].trim())}</em>`;
  return escapeHtml(t);
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}
